class MessageError extends Error {
  /**
   *
   * @param title
   * @param message
   */
  constructor({ title = "", message = "" } = {}) {
    super(`${title} ${message}`);
    this.name = "MessageError";
    this.title = title;
    this.message = message;
  }
}

export default MessageError;
